import React, { ReactNode, ReactElement } from 'react';
import { Modal as AntModal } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import { XmarkIcon } from '@revfluence/fresh-icons/solid';

export interface IModalProps extends ModalProps {
  children: ReactNode;
  okText?: React.ReactNode;
}

/**
 * Modal component
 */
export const Modal = (props: IModalProps): ReactElement => {
  const { closeIcon = <XmarkIcon />, okText = 'Ok' } = props;
  return <AntModal closeIcon={closeIcon} okText={okText} {...props} />;
};

Modal.useModal = AntModal.useModal;
Modal.info = AntModal.info;
Modal.confirm = AntModal.confirm;
Modal.success = AntModal.success;
Modal.warning = AntModal.warning;
Modal.warn = AntModal.warn;
Modal.error = AntModal.error;
